// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2750%27 height=%2750%27 viewBox=%270 0 50 50%27%3E%3Cpath fill=%27%232F2D37%27 d=%27M25,5A20.14,20.14,0,0,1,45,22.88a2.51,2.51,0,0,0,2.49,2.26h0A2.52,2.52,0,0,0,50,22.33a25.14,25.14,0,0,0-50,0,2.52,2.52,0,0,0,2.5,2.81h0A2.51,2.51,0,0,0,5,22.88,20.14,20.14,0,0,1,25,5Z%27%3E%3CanimateTransform attributeName=%27transform%27 type=%27rotate%27 from=%270 25 25%27 to=%27360 25 25%27 dur=%270.6s%27 repeatCount=%27indefinite%27/%3E%3C/path%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Main wrapper
 */
.select-search {
  position: relative;
  font-family: "Nunito Sans", sans-serif;
  box-sizing: border-box;
}

.select-search *,
.select-search *::after,
.select-search *::before {
  box-sizing: inherit;
}

/**
 * Value wrapper
 */
.select-search__value {
  position: relative;
  z-index: 2;
}

.select-search__value::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: calc(50% - 9px);
  right: 19px;
  width: 11px;
  height: 11px;
}

/**
 * Input
 */
.select-search__input {
  display: block;
  height: 36px;
  width: 100%;
  padding: 0 16px;
  background: #fff;
  border: 1px solid transparent;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  outline: none;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  text-align: left;
  text-overflow: ellipsis;
  line-height: 36px;
  -webkit-appearance: none;
  border-color: #ced4da;
}

.select-search__input::-webkit-search-decoration,
.select-search__input::-webkit-search-cancel-button,
.select-search__input::-webkit-search-results-button,
.select-search__input::-webkit-search-results-decoration {
  -webkit-appearance: none;
}

.select-search__input:not([readonly]):focus {
  cursor: initial;
}

/**
 * Options wrapper
 */
.select-search__select {
  background: #fff;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.15);
}

/**
 * Options
 */
.select-search__options {
  list-style: none;
  padding: 0;
}

/**
 * Option row
 */
.select-search__row:not(:first-child) {
  border-top: 1px solid #eee;
}

/**
 * Option
 */
.select-search__option,
.select-search__not-found {
  display: block;
  height: 36px;
  width: 100%;
  padding: 0 16px;
  background: #fff;
  border: none;
  outline: none;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
}

.select-search--multiple .select-search__option {
  height: 48px;
}

.select-search__option.is-selected {
  background: #2fcc8b;
  color: #fff;
}

.select-search__option.is-highlighted,
.select-search__option:not(.is-selected):hover {
  background: rgba(47, 204, 139, 0.1);
}

.select-search__option.is-highlighted.is-selected,
.select-search__option.is-selected:hover {
  background: #2eb378;
  color: #fff;
}

/**
 * Group
 */
.select-search__group-header {
  font-size: 10px;
  text-transform: uppercase;
  background: #eee;
  padding: 8px 16px;
}

/**
 * States
 */
.select-search.is-disabled {
  opacity: 0.5;
}

.select-search.is-loading .select-search__value::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 11px;
}

.select-search:not(.is-disabled) .select-search__input {
  cursor: pointer;
}

/**
 * Modifiers
 */
.select-search--multiple {
  border-radius: 3px;
  overflow: hidden;
}

.select-search:not(.is-loading):not(.select-search--multiple)
  .select-search__value::after {
  transform: rotate(45deg);
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  pointer-events: none;
}

.select-search--multiple .select-search__input {
  cursor: initial;
}

.select-search--multiple .select-search__input {
  border-radius: 3px 3px 0 0;
}

.select-search--multiple:not(.select-search--search) .select-search__input {
  cursor: default;
}

.select-search:not(.select-search--multiple) .select-search__input:hover {
  border-color: #2fcc8b;
}

.select-search:not(.select-search--multiple) .select-search__select {
  position: absolute;
  z-index: 3;
  top: 44px;
  right: 0;
  left: 0;
  border-radius: 3px;
  overflow: auto;
  max-height: 360px;
}

.select-search--multiple .select-search__select {
  position: relative;
  overflow: auto;
  max-height: 260px;
  border-top: 1px solid #eee;
  border-radius: 0 0 3px 3px;
}

.select-search__not-found {
  height: auto;
  padding: 16px;
  text-align: center;
  color: #888;
}
`, "",{"version":3,"sources":["webpack://./src/components/formik/FormikSearchDropdown/FormikSearchDropdown.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,kBAAkB;EAClB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE;AACF;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,oDAAoD;EACpD,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE;AACF;EACE,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;;EAEE;AACF;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE;AACF;EACE,0BAA0B;AAC5B;;AAEA;;EAEE;AACF;;EAEE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE;AACF;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE;AACF;EACE,YAAY;AACd;;AAEA;EACE,yDAAgf;EAChf,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,OAAO;EACP,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb","sourcesContent":["/**\n * Main wrapper\n */\n.select-search {\n  position: relative;\n  font-family: \"Nunito Sans\", sans-serif;\n  box-sizing: border-box;\n}\n\n.select-search *,\n.select-search *::after,\n.select-search *::before {\n  box-sizing: inherit;\n}\n\n/**\n * Value wrapper\n */\n.select-search__value {\n  position: relative;\n  z-index: 2;\n}\n\n.select-search__value::after {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  top: calc(50% - 9px);\n  right: 19px;\n  width: 11px;\n  height: 11px;\n}\n\n/**\n * Input\n */\n.select-search__input {\n  display: block;\n  height: 36px;\n  width: 100%;\n  padding: 0 16px;\n  background: #fff;\n  border: 1px solid transparent;\n  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.15);\n  border-radius: 3px;\n  outline: none;\n  font-family: \"Noto Sans\", sans-serif;\n  font-size: 14px;\n  text-align: left;\n  text-overflow: ellipsis;\n  line-height: 36px;\n  -webkit-appearance: none;\n  border-color: #ced4da;\n}\n\n.select-search__input::-webkit-search-decoration,\n.select-search__input::-webkit-search-cancel-button,\n.select-search__input::-webkit-search-results-button,\n.select-search__input::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n}\n\n.select-search__input:not([readonly]):focus {\n  cursor: initial;\n}\n\n/**\n * Options wrapper\n */\n.select-search__select {\n  background: #fff;\n  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.15);\n}\n\n/**\n * Options\n */\n.select-search__options {\n  list-style: none;\n  padding: 0;\n}\n\n/**\n * Option row\n */\n.select-search__row:not(:first-child) {\n  border-top: 1px solid #eee;\n}\n\n/**\n * Option\n */\n.select-search__option,\n.select-search__not-found {\n  display: block;\n  height: 36px;\n  width: 100%;\n  padding: 0 16px;\n  background: #fff;\n  border: none;\n  outline: none;\n  font-family: \"Noto Sans\", sans-serif;\n  font-size: 14px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.select-search--multiple .select-search__option {\n  height: 48px;\n}\n\n.select-search__option.is-selected {\n  background: #2fcc8b;\n  color: #fff;\n}\n\n.select-search__option.is-highlighted,\n.select-search__option:not(.is-selected):hover {\n  background: rgba(47, 204, 139, 0.1);\n}\n\n.select-search__option.is-highlighted.is-selected,\n.select-search__option.is-selected:hover {\n  background: #2eb378;\n  color: #fff;\n}\n\n/**\n * Group\n */\n.select-search__group-header {\n  font-size: 10px;\n  text-transform: uppercase;\n  background: #eee;\n  padding: 8px 16px;\n}\n\n/**\n * States\n */\n.select-search.is-disabled {\n  opacity: 0.5;\n}\n\n.select-search.is-loading .select-search__value::after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50' viewBox='0 0 50 50'%3E%3Cpath fill='%232F2D37' d='M25,5A20.14,20.14,0,0,1,45,22.88a2.51,2.51,0,0,0,2.49,2.26h0A2.52,2.52,0,0,0,50,22.33a25.14,25.14,0,0,0-50,0,2.52,2.52,0,0,0,2.5,2.81h0A2.51,2.51,0,0,0,5,22.88,20.14,20.14,0,0,1,25,5Z'%3E%3CanimateTransform attributeName='transform' type='rotate' from='0 25 25' to='360 25 25' dur='0.6s' repeatCount='indefinite'/%3E%3C/path%3E%3C/svg%3E\");\n  background-size: 11px;\n}\n\n.select-search:not(.is-disabled) .select-search__input {\n  cursor: pointer;\n}\n\n/**\n * Modifiers\n */\n.select-search--multiple {\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.select-search:not(.is-loading):not(.select-search--multiple)\n  .select-search__value::after {\n  transform: rotate(45deg);\n  border-right: 1px solid #000;\n  border-bottom: 1px solid #000;\n  pointer-events: none;\n}\n\n.select-search--multiple .select-search__input {\n  cursor: initial;\n}\n\n.select-search--multiple .select-search__input {\n  border-radius: 3px 3px 0 0;\n}\n\n.select-search--multiple:not(.select-search--search) .select-search__input {\n  cursor: default;\n}\n\n.select-search:not(.select-search--multiple) .select-search__input:hover {\n  border-color: #2fcc8b;\n}\n\n.select-search:not(.select-search--multiple) .select-search__select {\n  position: absolute;\n  z-index: 3;\n  top: 44px;\n  right: 0;\n  left: 0;\n  border-radius: 3px;\n  overflow: auto;\n  max-height: 360px;\n}\n\n.select-search--multiple .select-search__select {\n  position: relative;\n  overflow: auto;\n  max-height: 260px;\n  border-top: 1px solid #eee;\n  border-radius: 0 0 3px 3px;\n}\n\n.select-search__not-found {\n  height: auto;\n  padding: 16px;\n  text-align: center;\n  color: #888;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
